import { render, staticRenderFns } from "./EarlyCollegeSummit2024StudentSpeaker.vue?vue&type=template&id=b2c80248&scoped=true"
var script = {}
import style0 from "./EarlyCollegeSummit2024StudentSpeaker.vue?vue&type=style&index=0&id=b2c80248&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b2c80248",
  null
  
)

export default component.exports